import axios from 'axios'

export const requisicaoWeb = axios.create();